import React from "react";
import "./Quick_Access.css";
import { useNavigate } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";

const Quick_Access = () => {
  const tabs = [
    {
      label: "Create Invoice",
      img: "/Assets/Images/dashboard/img1.png",
      link:"/create-invoice"
    },
    {
      label: "Invoices",
      img: "/Assets/Images/dashboard/img2.png",
      link:"/invoices"
    },
    {
      label: "Add Party",
      img: "/Assets/Images/dashboard/img3.png",
      link:"/add-party"
    },
    {
      label: "Parties",
      img: "/Assets/Images/dashboard/img4.png",
      link:"/parties"
    },
    {
      label: "Vendor Management",
      img: "/Assets/Images/dashboard/img5.png",
      link:"/vendor-management"
    },
    {
      label: "Add Products",
      img: "/Assets/Images/dashboard/img6.png",
      link:"/add-products",
    },
  ];

  const navigate = useNavigate()

  return (
    <section className="Quick_Access">
      <p className="section_title">Quick Access</p>

      <div className="all_tabs_holder">
        {tabs?.map((item,index) => {
          return (
            <div  className={`colourd_box box_${index+1}`} onClick={() => {navigate(item?.link)}}>
              <div className="icon_holder">
                <img
                  src={process.env.PUBLIC_URL + item?.img}
                  className="inner_icon"
                />
              </div>
              <div className="label_div">
                <p className="label_text">{item?.label}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Quick_Access;
